/**
 * @fileoverview GET handler for the "/engagement/api/suppression_lists" endpoint
 */
import fetch from "@lib/fetch";

import type { EngagementSegmentsParams, SuppressionListsResults } from "../engagementSegments";
import { formatParams } from "../engagementSegments";
import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementApiSuppressionLists } from "./constants";

export const getEngagementApiSuppressionLists = reactQueryTableFetcherAdapter(
  engagementApiSuppressionLists,
  (signal: AbortSignal, params: EngagementSegmentsParams): Promise<SuppressionListsResults> => {
    return fetch("/engagement/api/suppression_lists", "GET", formatParams(params), { signal });
  }
);
